import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, Observable, of } from 'rxjs';
import { TranscriptResponseModel } from '../core';

@Injectable({ providedIn: 'root' })
export class PortalService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'Portal');
  }

  public getTranscript(conversationId: string): Observable<TranscriptResponseModel | null> {
    const id = (conversationId || '').trim();

    if (!id) {
      return of(null);
    }

    const url = `${this.route()}/${encodeURIComponent(id)}/transcript`;

    return this.http.get<TranscriptResponseModel>(url).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          return of(null);
        }

        throw error;
      }),
    );
  }
}
